export default __webpack_public_path__ + "static/media/AlternativeLogomark_purple_black_white-01.3d43512f.png";